import index from "./access.vue";
export default index;
